import React, {useState} from 'react'
import PropTypes from 'prop-types';
import Dropzone from 'components/Dropzone'
import UploadService from 'services/UploadService';
import {Typography} from '@material-ui/core';
import Endpoints from "constants/Endpoints";
import Dialog from "components/Dialog";
import Tr from "translations/Translations";
import Button from "components/Button";
import SimpleTable from "components/complex/simpleTable/SimpleTable";
import clsx from "clsx";
import {clearResource, setOpenForm, setOpenImporter, setStepperState} from "redux/actions";
import {connect} from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";
import DealingsService from "services/DealingsService";
import LoadingScreen from "components/complex/loadingScreen/LoadingScreen";

const useStyle = makeStyles((theme) => ({
    dropzone: {
        marginTop: theme.spacing(1)
    },
    lpColumn: theme.components.table.lpColumn,
    reasonColumn: {
        color: theme.palette.error.main
    },
    buttonRow: {
        textAlign: "end"
    }

}));

function UploadImportFile(
    {
        id,
        clearResource,
        setStepperState,
        setUploadOpened,
        setOpenImporter,
        setOpenForm,
        ...others
    }) {

    const classes = useStyle();

    // eslint-disable-next-line
    const [importErrors, setImportErrors] = useState([]);
    const [processingUpload, setProcessingUpload] = useState(false);
    const [openSuccessPopup, setOpenSuccessPopup] = useState(false);

    const handlePickFile = (files) => {
        setProcessingUpload(true);

        //start upload
        files.forEach((element, index) => {
            UploadService.upload(element, () => {
            }, Endpoints.DEALINGS_IMPORT(id)).then(res => {
                if (res.success) {
                    setOpenSuccessPopup(true);
                } else {
                    setImportErrors(res.errors)
                }
            }).catch((e) => {
                console.error(e);
                setImportErrors([Tr("unknown_error_message")])
            }).finally(() => setProcessingUpload(false))
        });
    };
    const clearImportErrors = () => {
        setImportErrors([]);
    };

    const handleCloseSuccessPopup = () => {
        setOpenSuccessPopup(false);
        DealingsService.clearResources('dealing');
        DealingsService.clearResources('dealingsList');
        DealingsService.getList(id).then(() => {
            setOpenImporter(false);
            setOpenForm(true);
        });
    };

    return (
        <>
            <LoadingScreen open={processingUpload}/>

            <Dropzone
                className={classes.dropzone}
                onChange={handlePickFile}
                acceptExtensionList={['xlsx']}
                {...others}
            />
            <Dialog
                title={Tr('attention')}
                open={importErrors.length > 0}
                titleCentered
                maxWidth={'md'}
                fullWidth={true}
                onClose={clearImportErrors}
            >
                <Typography>
                    {Tr('import_upload_dialog_error')}
                </Typography>
                <div>
                    <SimpleTable
                        columnClasses={[
                            classes.lpColumn,
                            classes.reasonColumn
                        ]}
                        headers={[Tr('column_lp'), Tr('reason')]}
                        items={importErrors.map((e, index) => [(index + 1), e])}
                    />

                    <div className={clsx(classes.buttonRow, classes.dropzone)}>
                        <Button
                            onClick={clearImportErrors}
                        >
                            {Tr('close')}
                        </Button>
                    </div>

                </div>
            </Dialog>
            <Dialog
                title={Tr('attention')}
                open={openSuccessPopup}
                titleCentered
                maxWidth={'md'}
                fullWidth={true}
                onClose={handleCloseSuccessPopup}
            >
                <Typography>
                    {Tr('import_upload_dialog_success_line1')}
                </Typography>
                <Typography>
                    {Tr('import_upload_dialog_success_line2')}
                </Typography>
                <div className={clsx(classes.buttonRow, classes.dropzone)}>
                    <Button
                        onClick={handleCloseSuccessPopup}
                    >
                        {Tr('close')}
                    </Button>
                </div>
            </Dialog>
        </>
    )
}

UploadImportFile.propTypes = {
    classes: PropTypes.any,

};

export default connect((state) => ({}), {
    setOpenImporter,
    setOpenForm,
    setStepperState,
    clearResource
})(UploadImportFile);